// @ts-nocheck
import Head from 'next/head'
import React, {useEffect, useState} from "react";

import {useRouter} from "next/router";
import {getStoryblokApi} from "@storyblok/react";
import BlogPostSkeleton from "../components/blog/BlogPostSkeleton";
import BlogPostCard from "../components/blog/BlogPostCard";
import BaseLayout from "../components/layouts/BaseLayout";
// Import Swiper React components
import { Navigation } from 'swiper/modules';
import {Swiper as SwiperComponent, SwiperSlide} from 'swiper/react';

// Import Swiper styles
// import 'swiper/css';
// import "swiper/css/navigation";

export default function Blog(props: any) {
    const router = useRouter();

    const [loadingState, setLoadingState] = useState(false)


    const [slidesPerView, setSlidesPerView] = useState(3);

    const adjustSlides = () => {

        if (window.innerWidth > 900) {
            setSlidesPerView(3);

        } else if (window.innerWidth > 640) {
            setSlidesPerView(2);
        } else {
            setSlidesPerView(1);
        }

    }

    if (typeof window !== 'undefined') {
        window.addEventListener('resize', adjustSlides);
    }

    useEffect(() => {
        adjustSlides()
    });

    let blogPosts = props.data.filter((el: { tag_list: string | string[]; }) => {
        if (el.tag_list && el.tag_list.indexOf("Tech") !== -1) {
            return false;
        }
        return true;
    })

    let techBlogPosts = props.tech;

    let skeletonItems = [];
    for (let i = 0; i < 10; i++) {
        skeletonItems.push(<BlogPostSkeleton key={i}/>)
    }

    // @ts-ignore
    return (

        <>
            <Head>
                <title>{"Blog - Stories about Web Development, Web Design, Software Development"}</title>
                <meta name={'description'}
                      content={"Learn more about web design, web development and software engineering in our exciting blog posts."}/>
                <link rel="canonical" href={"https://www.pacificcodeline.com/blog"}/>

                <link rel="icon" href="/favicon.png"/>
            </Head>

            <BaseLayout
                navigation={props.navigation}
                footer={props.footer}
                invert={false}
            >

                <main className={"blog-page"}>

                    <div className={"max-w-7xl mx-auto"}>

                        {loadingState &&
                            <div>
                                <div>
                                    {skeletonItems}
                                </div>
                            </div>
                        }

                        {!loadingState &&
                            <React.Fragment>

                                <div className="bg-white padding-normal">
                                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                                        <div className="mx-auto max-w-2xl text-center">
                                            <h1 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">From
                                                the Blog</h1>
                                            <p className="mt-2 text-lg leading-8 text-gray-600">
                                                Stories about software development, web development, and more.
                                            </p>
                                        </div>
                                        <div
                                            className="mx-auto mt-16  max-w-2xl gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none swiper-blog">
                                            <div className={"relative w-full overflow-hidden"}>
                                                <div className={"px-16"}>
                                                    <SwiperComponent
                                                        navigation={{
                                                            nextEl: ".swiper-blog .swiper-button-next",
                                                            prevEl: ".swiper-blog .swiper-button-prev",
                                                        }}
                                                        modules={[Navigation]}
                                                        loop={true}
                                                        spaceBetween={50}
                                                        slidesPerView={slidesPerView}
                                                        // onSlideChange={() => console.log('slide change')}
                                                        // onSwiper={(swiper) => console.log(swiper)}
                                                    >
                                                        {blogPosts.map((el: any, idx: any) => {
                                                            return <SwiperSlide key={idx}>
                                                                <BlogPostCard el={el}/>
                                                            </SwiperSlide>
                                                        })}
                                                    </SwiperComponent>
                                                </div>
                                                <div className="swiper-button-prev"></div>
                                                <div className="swiper-button-next"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="bg-white padding-normal">
                                    <div className="mx-auto max-w-7xl px-6 lg:px-8">
                                        <div className="mx-auto max-w-2xl text-center">
                                            <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">From
                                                the Developer&apos;s Blog</h2>
                                            <p className="mt-2 text-lg leading-8 text-gray-600">
                                                Stories about software development, web development, and more.
                                            </p>
                                        </div>
                                        <div
                                            className="mx-auto mt-16 max-w-2xl gap-y-20 lg:mx-0 lg:max-w-none swiper-tech">

                                            <div className={"relative"}>
                                                <div className={"px-16 "}>
                                                    <SwiperComponent
                                                        navigation={{
                                                            nextEl: ".swiper-tech .swiper-button-next",
                                                            prevEl: ".swiper-tech .swiper-button-prev",
                                                        }}
                                                        modules={[Navigation]}
                                                        loop={true}
                                                        spaceBetween={50}
                                                        slidesPerView={slidesPerView}
                                                        // onSlideChange={() => console.log('slide change')}
                                                        // onSwiper={(swiper) => console.log(swiper)}
                                                    >
                                                        {techBlogPosts.map((el: any, idx: any) => {
                                                            return <SwiperSlide key={idx}>
                                                                <BlogPostCard el={el}/>
                                                            </SwiperSlide>
                                                        })}
                                                    </SwiperComponent>
                                                </div>
                                                <div className="swiper-button-prev"></div>
                                                <div className="swiper-button-next"></div>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </React.Fragment>
                        }


                    </div>


                </main>
            </BaseLayout>
        </>

    )
};


interface IStaticProps {
    preview: Boolean,
    params: { slug: Array<string> }
}

export async function getStaticProps({preview, params}: IStaticProps) {
    const storyblokApi = getStoryblokApi();

    let sbParams = {
        version: "published", // or 'published',
        resolve_relations: "SuccessStoriesSmall.posts,Relationship.story",
    };

    if (preview) {
        sbParams.version = "draft";
    }


    let data: any = [];
    let tech: any = [];

    const langPrefix = "en/";

    try {
        // await storyblokApi.flushCache()
        let navigation = await storyblokApi.get(`cdn/stories/mainnavigation`, sbParams);
        let footer = await storyblokApi.get(`cdn/stories/footer`, sbParams);

        let projects = await storyblokApi.get(`cdn/stories`, {
            "starts_with": "project-history/",
            "sort_by": "content.year:desc",
            "filter_query": {
                "website": {
                    "is": true,
                },
                "ongoing": {
                    is: true
                }
            },
            per_page: 3,
            page: 1
        });


        await storyblokApi.get('cdn/stories', {
            "starts_with": "blog/",
            sort_by: "content.date:desc",
        })
            .then(response => {
                data = response.data.stories.filter((item: { full_slug: string | string[]; }) => item.full_slug.indexOf('/tech') === -1);
            }).catch(error => {
            })

        await storyblokApi.get('cdn/stories', {
            "starts_with": "blog/tech",
            //"with_tag": "Tech",
        })
            .then(response => {
                tech = response.data.stories;

            }).catch(error => {

            })


        return {
            props: {
                navigation: navigation ? navigation.data.story : false,
                footer: footer ? footer.data.story : false,
                preview: false,
                projects,
                data,
                tech
            },
            revalidate: 360000000000, // 3600,
        };


    } catch (e) {
        return {
            notFound: true
        }
    }

};
